// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8d0468c2","21":"6d04840a","48":"d9e4badb","326":"4cd35fb9","433":"e6a85690","546":"5bf146fe","569":"4c33f91d","606":"487975aa","657":"5c3ce913","671":"20658657","700":"5f781c11","747":"be42c6a0","830":"004d9444","998":"5d1a1938"}[chunkId] + ".chunk.js";
};